import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminMain from "./AdminMain";
import AdminAnalitica from "./AdminAnalica";
import Cookies from "js-cookie";
import AdminCategory from "./AdminCategory";
import AdminCategoryAdd from "./AdminCategoryAdd";
import AdminCategoryEdit from "./AdminCategoryEdit";
import AdminBrend from "./AdminBrend";
import AdminBrendAdd from "./AdminBrendAdd";
import AdminBrendEdit from "./AdminBrendEdit";
import AdminProducts from "./AdminProducts";
import AdminProductsAdd from "./AdminProductsAdd";
import AdminProductsEdit from "./AdminProductsEdit";
import AdminOrderLocation from "./AdminOrderLocation";
import AdminOrderPrice from "./AdminOrderPrice";
import AdminOrders from "./AdminOrders";
import AdminOrderDetails from "./AdminOrderDetails";
import AdminOrderTime from "./AdminOrderTime";
import AdminBanner from "./AdminBanner";
import AdminBannerAdd from "./AdminBannerAdd";
import AdminBannerEdit from "./AdminBannerEdit";
import AdminUsers from "./AdminUsers";
import AdminUsersAdd from "./AdminUsersAdd";
import AdminUsersEdit from "./AdminUsersEdit";
import AboutUs from "./AboutUs";
import Control from "./Control";
import Comment from "./Coment";
import Payment from "./Payment";
import MobileUpdate from "./MobileUpdate";
import Notification from "./Notification";
import { SocketProvider } from "../Context/OrdersSocket.jsx";
import Iosnotific from "./Iosnotific.jsx";


export default function AdminPage() {
  const [isSidebarExpanded, setSidebarExpanded] = useState(() => {
    const savedState = Cookies.get("sidebarExpanded");
    return savedState === "true";
  });

  const toggleSidebar = () => {
    const newExpandedState = !isSidebarExpanded;
    setSidebarExpanded(newExpandedState);

    Cookies.set("sidebarExpanded", newExpandedState, {
      expires: 365,
      path: "/",
    });
  };

  return (
    <div className="admin-page-container">
      <AdminSidebar
        isExpanded={isSidebarExpanded}
        handleToggle={toggleSidebar}
      />
      <SocketProvider>
        <Routes>
          <Route path="home" element={<AdminMain />} />
          <Route path="home/analitica" element={<AdminAnalitica />} />
          <Route path="home/category" element={<AdminCategory />} />
          <Route path="home/category/add" element={<AdminCategoryAdd />} />
          <Route
            path="home/category/edit/:id"
            element={<AdminCategoryEdit />}
          />
          <Route path="home/brends" element={<AdminBrend />} />
          <Route path="home/brends/add" element={<AdminBrendAdd />} />
          <Route path="home/brends/edit/:id" element={<AdminBrendEdit />} />
          <Route path="home/products" element={<AdminProducts />} />
          <Route path="home/products/add" element={<AdminProductsAdd />} />
          <Route
            path="home/products/edit/:id"
            element={<AdminProductsEdit />}
          />
          <Route path="home/order-location" element={<AdminOrderLocation />} />
          <Route path="home/order-price" element={<AdminOrderPrice />} />
          <Route path="home/orders" element={<AdminOrders />} />
          <Route path="home/orders/:id" element={<AdminOrderDetails />} />
          <Route path="home/order-times" element={<AdminOrderTime />} />
          <Route path="home/banner" element={<AdminBanner />} />
          <Route path="home/banner/add" element={<AdminBannerAdd />} />
          <Route path="home/banner/edit/:id" element={<AdminBannerEdit />} />
          <Route path="home/users" element={<AdminUsers />} />
          <Route path="home/users/add" element={<AdminUsersAdd />} />
          <Route path="home/users/edit/:id" element={<AdminUsersEdit />} />
          <Route path="home/aboutus" element={<AboutUs />} />
          <Route path="home/control" element={<Control />} />
          <Route path="home/comments" element={<Comment />} />
          <Route path="home/payment" element={<Payment />} />
          <Route path="home/mobile-update" element={<MobileUpdate />} />
          <Route path="home/notifications" element={<Notification />} />
          <Route path="home/notifications/ios" element={<Iosnotific />} />

        </Routes>
      </SocketProvider>
    </div>
  );
}
